export const CURRENT_LOCATION = "Iran";
export const SHOW_OPEN_TO_WORK_BANNER = true;

export const BIRTH_DATE = new Date("2007-12-19");

export function getAge(referenceDate = new Date(), birthDate = BIRTH_DATE): number {
    const today = new Date(referenceDate);
    let age = today.getFullYear() - birthDate.getFullYear();

    const hasBirthdayPassed =
        today.getMonth() > birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

    if (!hasBirthdayPassed) {
        age -= 1;
    }

    return age;
}

// Alias for backwards-compatible, callable usage: AGE()
export const AGE = () => getAge();

export const LOCAL_TIME_IRAN = (() => {
    return new Date().toLocaleString("en", {
        timeZone: "Asia/Tehran",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
})();

export const AVAILABILITY = "Available for Full-Time Roles & Contracting";

export const LANGUAGES = ["English (C1)", "Persian (Native)"];

export const TARGET_ELEMENT_SCROLL_OFFSET = 150;
